// 免打扰设置
import { setChannelMute } from '_api/channel' 
import { mapGetters, mapMutations } from "vuex";
import { CHANNEL_TYPES } from '@/common/constants/channel'
import { IMTimeFormat } from '_lib/utils/utils'

import { getStoredNotifySetting, setNotifySetting } from '@/common/notifySettings'
import EventBus from '_lib/EventBus';

const mute_list = [{
  label: '持续15分钟',
  duration: 15 * 60
}, {
  label: '持续1小时',
  duration: 60 * 60
}, {
  label: '持续8小时',
  duration: 8 * 60 * 60
}, {
  label: '持续24小时',
  duration: 24 * 60 * 60
}, {
  label: '直到我手动关闭',
  duration: -1
}]

export default {
  computed: {
    ...mapGetters([
      'cur_room_data',
      'room_list',
      'all_notify_settings'
    ]),
    isCurRoomTemp() {
      let isCurRoomTemp = false;
      if (this.cur_room_data && this.cur_room_data.room_id && this.cur_room_data.room_name && !this.room_list.find(item => item.room_id === this.cur_room_data.room_id)) {
        isCurRoomTemp = true;
      }
      return isCurRoomTemp;
    },
  },
  methods: {
    async setMuteNotify ({ room_id, channel_id, dnds }) {
      await setNotifySetting(room_id, channel_id, { dnds })
      this.$unread.updateUnreadStateCache({
        room_id,
        channel_id,
      }, true);
    },
    getRoomMuteMenuAction(room_id) {
      const room_notify_settings = getStoredNotifySetting(room_id)
      const dnds = room_notify_settings?.dnds
      const left_mute_time = Number(dnds?.until)
      const menu = {
        component: 'menu-action',
        onClick: () => {
          EventBus.$dynamic('SetRoomNotifyDialog', { room_id })
        }
      }
      const no_mute_data = {
        data: {
          label: '消息免打扰',
          icon: 'icon-notice-bold'
        },
      }
      const has_mute_data = {
        data: {
          label: `消息免打扰`,
          icon: 'icon-notice-off-bold',
          desc: left_mute_time == -1 ? '静音至：直到我手动关闭' : `静音至：${IMTimeFormat(left_mute_time * 1000, false, false)}`
        },
      }
      const second = (left_mute_time - Date.parse(new Date()) / 1000)
      if (second > 0) {
        this.setMuteTimer(room_id, '', second)
      }
      const config = (second > 0 || left_mute_time - 1) ? has_mute_data : no_mute_data
      return {
        ...menu,
        ...config
      }
    },
    // 获取选择的频道是否被免打扰了，以及对应的menu
    getMuteMenu (channel, room = null) {
      room = room || this.cur_room_data
      let menu = {
        items: [{hidden: true}]
      }
      if (!room?.room_id 
        || channel?.channel_type === CHANNEL_TYPES.temporary_group 
        || channel?.channel_type === CHANNEL_TYPES.custom // 自定义频道不显示免打扰设置
        || this.isCurRoomTemp) {
        return menu
      }
      const select_room_notify_settings = getStoredNotifySetting(room.room_id)
      let left_mute_time = 0 // 剩余免打扰时间
      if (channel) {
        const select_channel_notify_settings = getStoredNotifySetting(room.room_id, channel.channel_id, channel.channel_type)
        left_mute_time = select_channel_notify_settings?.dnds?.until || 0
      } else {
        left_mute_time = select_room_notify_settings?.dnds?.until || 0
      }
      left_mute_time = Number(left_mute_time)
      const no_mute_menu = [{
        component: 'child-menu',
        data: {
          label: (!channel ? '房间' : channel?.channel_type == CHANNEL_TYPES.group ? '分组' : '频道') + '免打扰',
          childStyles: {
            'min-width': '133px'
          },
          groups: [
            {
              items: mute_list.map(mute => {
                return {
                  component: 'menu-button',
                  data: {
                    label: mute.label,
                  },
                  onClick: () => {
                    setChannelMute({}, {
                      duration: mute.duration,
                      channel_id: channel?.channel_id || '',
                      room_id: room.room_id || '',
                    }).then(()=>{
                      this.setMuteNotify({
                        room_id: room.room_id,
                        channel_id: channel?.channel_id,
                        dnds: {
                          duration: mute.duration,
                          until: mute.duration == -1 ? -1 : (Date.parse(new Date()) / 1000 + mute.duration)
                        }
                      })
                    })
                  }
                }
              })
            }
          ]
        }
      }]
      const has_mute_menu = [{
        component: 'menu-button',
        data: {
          height50: left_mute_time != -1,
          label: `取消免打扰${left_mute_time == -1 ? '' : '<p>静音至：' + IMTimeFormat(left_mute_time * 1000, false, false)}</p>`,
        },
        onClick: () => {
          setChannelMute({}, {
            duration: 0,
            channel_id: channel?.channel_id || '',
            room_id: room.room_id || '',
          }).then(()=>{
            this.setMuteNotify({
              room_id: room.room_id,
              channel_id: channel?.channel_id,
              dnds: null
            })
          })
        }
      }]
      const second = left_mute_time ? (left_mute_time - Date.parse(new Date()) / 1000) : 0
      if (second > 0) {
        this.setMuteTimer(room.room_id, channel?.channel_id, second)
      }
      menu = {
        items: (second > 0 || left_mute_time === -1) ? has_mute_menu : no_mute_menu
      }
      return menu
    },
    setMuteTimer(room_id, channel_id, second) {
      const key = `_mute_timer_${room_id}_${channel_id || ''}`
      clearTimeout(window[key])
      window[key] = setTimeout(() => {
        this.setMuteNotify({ room_id, channel_id, dnds: null })
      }, second * 1000)
    }
  },
}
